<template>
  <div>
    <transition name="slide-fade">
      <div class="audio_player" v-show="isShow">
        <div class="container client_container">
          <div class="audio_wrap">
            <div class="audio_content">
              <div class="audio_img">
                <img :src="courseInfo.imgCover" alt="">
                <router-link :to="courseInfo.pathname" class="course_link"/>
              </div>
              <div @click="deleteMedia" class="audio_delet_btn">
                <!-- <i class="far fa-times-circle"></i> -->
                <img
                  src="@/assets/images/audio/btn_mobile_player_close.png"
                  alt="btn_mobile_player_close"
                >
              </div>
              <div class="player_title">
                <div class="course_title">
                  <p class="player_title_text ellipsis_twoLine">
                    {{courseInfo.title}}
                  </p>
                  <router-link :to="courseInfo.pathname" class="course_link"/>
                </div>
                <p class="player_title_text arist_text ellipsis_oneLine">
                  {{courseInfo.author}}
                </p>
              </div>
            </div>
            <div class="audio_mid">
              <div class="lesson_title">
                <div class="lesson_text ellipsis_oneLine">
                  {{trackInfo.trackTitle}}
                  <router-link :to="courseInfo.pathname" class="lesson_link">
                  </router-link>
                </div>
                <!-- <router-link :to="courseInfo.pathname" class="course_link"/> -->
              </div>
              <div class="selectBar">
                <span
                  @click="prevAudio"
                  class="selectBar_icon prev_icon"
                >
                  <!-- <i class="fas fa-step-backward"></i> -->
                  <img
                    src="@/assets/images/audio/btn_player_backward.png"
                    alt="btn_player_backward"
                  >
                </span>
                <span
                 @click="isPlaying = !isPlaying"
                 class="selectBar_icon play_icon"
                >
                  <!-- <i v-show="!isPlaying" class="fas fa-play"></i> -->
                  <img
                    v-show="!isPlaying"
                    src="@/assets/images/audio/btn_player_play.png"
                    alt="btn_player_play"
                  >
                  <img
                    v-show="isPlaying"
                    src="@/assets/images/audio/btn_player_stop.png"
                    alt="btn_player_stop"
                  >
                  <!-- <i v-show="isPlaying" class="fas fa-pause"></i> -->
                </span>
                <span
                  @click="nextAudio"
                  class="selectBar_icon next_icon"
                >
                  <!-- <i class="fas fa-step-forward"></i> -->
                  <img
                    src="@/assets/images/audio/btn_player_forward.png"
                    alt="btn_player_forward"
                  >
                </span>
              </div>
            </div>
            <div class="audio_controller">
              <VolumeBar
                @changeVolume="changeVolume"
                @toggleMute="toggleMute"
                class="volumeBar"
              />
            </div>
          </div>
          <div
            @click="isShow = false"
            class="hide_btn"
          >
            <!-- <i class="fas fa-angle-down"></i> -->
            <img
              src="@/assets/images/audio/btn_player_arrowdown.png"
              alt="btn_player_arrowdown"
            >
          </div>
        </div>
        <div id="aplayer"></div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        v-show="!isShow && !shutDownPlayer"
        @click="isShow = true"
        class="showPlayer_btn">
        <div class="icon">
          <img src="@/assets/images/audio/btn_player_arrowup.png" alt="btn_player_arrowup">
        </div>
        <lottie :options="defaultOptions" :height="25" :width="25" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { returnBorrowCourse } from '@/api/toB'
import APlayer from 'aplayer'
import 'aplayer/dist/APlayer.min.css'
import Hls from 'hls.js'
// const hls = new Hls();
import lottie from 'vue-lottie'
import * as animationData from '@/assets/json/wave_24x24_white.json'
import VolumeBar from './components/VolumeBar'

export default {
  name: 'audioPlayer',
  components: {
    VolumeBar,
    lottie
  },
  data () {
    return {
      player: undefined,
      defaultOptions: { animationData: animationData },
      isIphone: false
    }
  },
  computed: {
    ...mapState({
      trackList: state => state.audio.trackList,
      courseInfo: state => state.audio.courseInfo,
      playImg: state => state.audio.playImg
    }),
    ...mapGetters('audio', {
      mediaList: 'mediaList'
    }),
    currentIdx: {
      get () {
        return this.$store.state.audio.currentIdx
      },
      set (value) {
        this.$store.commit('audio/setCurrentIdx', value)
      }
    },
    trackInfo: {
      get () {
        return this.$store.state.audio.trackInfo
      },
      set (value) {
        this.$store.commit('audio/setTrackInfo', value)
      }
    },
    isPlaying: {
      get () {
        return this.$store.state.audio.isPlaying
      },
      set (value) {
        this.$store.commit('audio/setIsPlaying', value)
      }
    },
    isShow: {
      get () {
        return this.$store.state.audio.isShow
      },
      set (value) {
        this.$store.commit('audio/setIsShow', value)
      }
    },
    shutDownPlayer: {
      get () {
        return this.$store.state.audio.shutDownPlayer
      },
      set (value) {
        this.$store.commit('audio/setShutDownPlayer', value)
      }
    }
  },
  watch: {
    trackInfo: function () {
      // console.log(this.player.list)
      // console.log(this.trackInfo)
      if (Object.keys(this.trackInfo).length === 0) {
        return // 如果為空,返回false
      }
      if (this.shutDownPlayer === true) {
        this.openMedia()
        this.shutDownPlayer = false
        this.addAudio()
        if (!this.isIphone) {
          this.isPlaying = true
        }
      } else {
        this.addAudio()
        this.isPlaying = true
      }
    },
    isPlaying: function () {
      this.togglePlay()
    }
    // shutDownPlayer: function () {
    //   if (this.shutDownPlayer === false) {
    //     this.openMedia()
    //   }
    // }
  },
  methods: {
    ...mapActions('audio', [
      'setTrackInfo'
    ]),
    creatAudioPlayer () {
      // console.log('4. creatAudioPlayer')
      const vm = this
      vm.player = new APlayer({
        container: document.getElementById('aplayer'),
        loop: 'none',
        theme: '#176E8D',
        customAudioType: {
          customHls: function (audioElement, audio, player) {
            if (Hls.isSupported()) {
              const config = {
                debug: true,
                xhrSetup: function (xhr, url) {
                  xhr.withCredentials = true
                }
              }
              const hls = new Hls(config)
              hls.loadSource(audio.url)
              hls.attachMedia(audioElement)
            } else if (audioElement.canPlayType('application/x-mpegURL') || audioElement.canPlayType('application/vnd.apple.mpegURL')) {
              audioElement.src = audio.url
            } else {
              player.notice('Error: HLS is not supported.')
            }
          }
        }
      })
      // console.log(vm.player.template.barWrap)
      vm.player.list.hide()
      vm.player.on('ended', function () {
        // console.log('player ended')
        const nextIdx = vm.getNextMusicIdx('step')
        if (nextIdx === 0) {
          this.isPlaying = false
        } else {
          vm.setAudio(nextIdx)
        }
      })
      // vm.player.on('volumechange', function () {
      //   console.log(vm.player.audio.volume)
      // })
      // console.log(vm.player.list)
    },
    addAudio (id) {
      // console.log('5. addAudio')
      const vm = this
      if (this.isShow === false) {
        this.isShow = true
      }
      // console.log(vm.trackInfo)
      // console.log(vm.player.list)
      vm.player.list.clear()
      vm.player.list.add(vm.mediaList)
      vm.isPlaying ? vm.player.play() : vm.player.pause()
    },
    // 播放 / 暫停
    togglePlay (nextIsPlaying = !this.isPlaying) {
      // console.log(this.isPlaying)
      const vm = this
      if (this.isPlaying === false) {
        // 播放
        vm.player.pause()
        // this.setPlayStatus(true)
        // .then(() => this.setPlayStatus(true))
        // .catch(e => console.error('播放發生錯誤', e))
      } else {
        // 暫停
        vm.player.play()
        // this.setPlayStatus(false)
      }
    },
    // 調整播放狀態
    setPlayStatus (val) {
      if (typeof val !== 'boolean') return
      this.isPlaying = val
      // this.player.dispatchEvent(this.event.isPlaying);
    },
    // 取得下一首要播放的歌曲
    setAudio (index) {
      // console.log('2: audioSetTrack')
      const trackItem = this.trackList[index]
      // console.log(trackItem)
      const borrowTime = localStorage.getItem('borrowTime')
      if (borrowTime !== null && !trackItem.free) {
        // console.log('check time')
        const timeNow = new Date().getTime()
        const borrowTimeObj = JSON.parse(localStorage.getItem('borrowTime'))
        // console.log(borrowTimeObj.timeout)
        if (timeNow > borrowTimeObj.timeout) {
          returnBorrowCourse(borrowTimeObj.id)
            .then(res => {
              // console.log(res.data)
              this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
              this.isPlaying = false
              localStorage.removeItem('borrowTime')
            })
            .catch((err) => {
              // console.log(err)
              localStorage.removeItem('borrowTime')
              if (err.response.status === 404) {
                this.fetchBorrowRecords()
                this.getBorrowQuantity(this.toBChannelID)
              }
              if (err.response.status === 422) {
                window.location.reload()
              }
              this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
              this.isPlaying = false
            })
          return
        }
      }

      const trackObj = {
        trackId: trackItem.id,
        trackTitle: trackItem.title,
        trackIsFree: trackItem.free,
        trackIndex: index
      }
      this.setTrackInfo(trackObj)
        .then((res) => {
          // console.log(res)
        })
        .catch((err) => {
          this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
          this.isPlaying = false
          console.log(err)
        })
    },
    getNextMusicIdx (operation) {
      // console.log(operation)
      let nextIdx = 0
      switch (operation) {
        case 'step':
          // 到播放清單底，結束播放
          if ((this.currentIdx + 1) >= this.trackList.length) {
            this.player.pause()
          }
          nextIdx = (this.currentIdx + 1) >= this.trackList.length ? 0 : this.currentIdx + 1
          break

        case 'next':
          //   case 'repeat-all':
          nextIdx = (this.currentIdx + 1) >= this.trackList.length ? 0 : this.currentIdx + 1
          break

        case 'prev':
          nextIdx = (this.currentIdx - 1) < 0 ? (this.trackList.length - 1) : (this.currentIdx - 1)
          break

      //   default:
      //     console.log('不合法的操作', operation);
      //     return;
      }
      // console.log(nextIdx)
      return nextIdx
    },
    openMedia () {
      this.creatAudioPlayer()
      // this.player.list.add(this.mediaList)
      this.isShow = true
    },
    showMedia () {
      this.isShow = !this.isShow
    },
    deleteMedia () {
      for (const key in this.trackInfo) {
        delete this.trackInfo[key]
      }
      // console.log(this.trackInfo)
      this.player.pause()
      this.player.destroy()
      this.isPlaying = false
      this.isShow = false
      // console.log(this.player)
      this.shutDownPlayer = true
      // this.player = {}
    },
    resetMedia () {
      // console.log('resetMedia')
      this.player.pause()
      this.player.list.clear()
      // this.mediaInfo = {}
      this.isPlaying = false
      this.isShow = false

      this.shutDownPlayer = true
    },
    prevAudio (audio) {
      if (this.isPlaying === false) {
        this.isPlaying = true
      }
      this.setAudio(this.getNextMusicIdx('prev'))
    },
    nextAudio (audio) {
      // if (this.isPlaying === false) {
      //   this.isPlaying = true
      // }
      this.setAudio(this.getNextMusicIdx('next'))
    },
    changeVolume (val) {
      this.player.volume((val / 100).toFixed(2), true)
    },
    toggleMute (val) {
      this.player.audio.muted = val
    },
    checkDevice () {
      this.isIphone = /iPhone/i.test(navigator.userAgent)
    }

  },
  mounted () {
    this.checkDevice()
  },
  destroyed () {
    if (this.player !== undefined) {
      this.isPlaying = false
      this.isShow = false
      this.player.destroy()
      this.shutDownPlayer = true
    }
  }
}
</script>

<style lang="scss" scoped >
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/css/all.min.css";
@import "../../../assets/scss/clients.scss";

.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  // position: relative;
  // top: 10px;
  opacity: 0;
}

.audio_player {
  margin: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
   background-color: rgba(0, 0, 0, 0.75);
  // background-color: #4a4a4a;
  height: 128px;
  @media (max-width: 767px) {
    // height: 68px;
    height: 88px;
  }
}
.audio_wrap {
  display: flex;
  justify-content: space-between;
  height: 128px;
  align-items: center;
  .course_link {
    position:absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: block;
    text-indent: -9999px;
  }
  @media (max-width: 767px) {
    height: 68px;
  }
}
.audio_content {
  display: flex;
  height: 88px;
  .audio_img {
    z-index: 10;
    position: relative;
    width: 132px;
    height: 88px;
    margin-right: 10px;
    overflow: hidden;
    display: inline-block;
    img {
      border-radius: 10px;
      object-fit: cover;
      max-height: 88px;
      width: 100%;
    }
  }
  .audio_delet_btn {
    z-index: 10;
    position: relative;
    color: white;
    align-self: center;
    display: none;
    cursor: pointer;
    width: 16px;
    img {
      width: 100%;
    }
  }
  .player_title {
    z-index: 10;
    position: relative;
    color: white;
    width: 210px;
    align-self: stretch;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    .course_title {
      position: relative;
    }
    .player_title_text {
      font-size: 20px;
      line-height: 26px;
      margin-bottom: 0;
    }
    .arist_text {
      font-size: 14px;
      line-height: 26px;
      color: white;
      opacity: 0.5;
    }
  }
  @media (max-width: 991px) {
    .player_title {
      width: 150px;
    }
  }
  @media (max-width: 767px) {
    height: 68px;
    .audio_img {
      display: none;
    }
    .audio_delet_btn {
      display: inline-block;
    }
    .player_title {
      display: none;
    }
  }
  @media (max-width: 575px) {
    audio_delet_btn {
      width: 18px;
    }
  }
}

.audio_mid {
  height: 88px;
  flex: auto;
  padding-left: 40px;
  .lesson_title {
    position: relative;
  }
  .lesson_text {
    color: white;
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 8px;
    position: relative;
    .lesson_link {
      color: white;
      text-decoration: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
    }
  }
  .selectBar {
    position: relative;
    z-index: 10;
    color: white;
    font-size: 2rem;
    align-self: center;
    display: flex;
    justify-content: center;
    .selectBar_icon {
      cursor: pointer;
    }
    .play_icon {
      margin: 0 50px;
    }
  }
  @media (max-width: 991px) {
    padding-left: 20px;
  }
  @media (max-width: 767px) {
    height: 68px;
    display: flex;
    .lesson_text {
      flex: auto;
      padding-top: 10px;
      // .lesson_link {
      //   display: none;
      // }
    }
    .selectBar {
      margin-left: auto;
      flex: 0 0 30px;
    }
    .selectBar .play_icon {
      margin: 0;
    }
    .prev_icon, .next_icon {
      display: none;
    }
  }
  @media (max-width: 575px) {
    .lesson_text {
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.audio_controller {
  display: flex;
  align-items: flex-start;
  align-self: flex-end;
  margin-bottom: 20px;
  .volumeBar {
    padding-top: 3px;
    z-index: 10;
    position: relative;
  }
  @media (max-width: 767px) {
    .volumeBar {
      display: none;
    }
  }
  @media (max-width: 575px) {
  }
}

.hide_btn {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 2.5rem;
  width: 40px;
  color: white;
  cursor: pointer;
  text-align: center;
  @media (max-width: 767px) {
    display: none;
  }
}

.aplayer {
  margin: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  margin-right: auto;
  margin-left: auto;
  box-shadow: none;
  @media (max-width: 767px) {
    padding-bottom: 20px;
  }
}
@media (min-width: 576px) {
  .aplayer {
    max-width: 800px;
    padding-right: 40px;
    padding-left: 40px;
  }
}
@media (min-width: 768px) {
  .client_container, .aplayer {
    max-width: 100%;
  }
}
// @media (min-width: 992px) {
//   .aplayer {
//     max-width: 800px;
//   }
// }
@media (min-width: 1280px) {
  .client_container, .aplayer {
    max-width: 960px;
  }
}
@media (min-width: 1500px) {
  .client_container, .aplayer {
    max-width: 1200px;
  }
}
.aplayer >>> .aplayer-body {
  display: flex;
  .aplayer-pic {
    width: 132px;
    float: none;
    opacity: 0;
    visibility: hidden;
    > .aplayer-play {
      display: none;
    }
  }
  .aplayer-info {
    display: flex;
    padding: 0;
    margin: 0;
    flex: auto;
    height: 100%;
    align-self: flex-end;
    margin-left: 255px;
    margin-bottom: 20px;
    .aplayer-music{
      margin: 0;
      // width: 180px;
      .aplayer-title, .aplayer-author {
        display: none;
      }
    }
    @media (max-width: 991px) {
      margin-left: 180px;
    }
    @media (max-width: 767px) {
      margin-right: 0;
      margin-left: 0;
      margin-bottom: 5px;
      padding-left: 20px;
    }
  }
  .aplayer-controller {
    align-items: center;
    flex: auto;
    .aplayer-bar-wrap {
      padding: 0;
      margin: 0;
      .aplayer-bar {
        height: 5px;
        border-radius: 3px;
        .aplayer-loaded,.aplayer-played {
          height: 5px;
          border-radius: 3px;
        }
        .aplayer-played .aplayer-thumb {
          height: 15px;
          width: 15px;
          display: none;
          margin-top: -5px;
        }
        .aplayer-played::after{
          content: "";
          width: 12px;
          height: 12px;
          background: white;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
    }
    .aplayer-time .aplayer-icon path,.aplayer-time .aplayer-icon:hover path{
      fill: white;
    }
    .aplayer-time {
      margin-right: 135px;
      align-self: flex-end;
      display: flex;
      align-items: flex-end;
      font-size: 14px;
    }
    .aplayer-volume-wrap, .aplayer-icon-loop {
      display: none;
    }
    @media (max-width: 991px) {
      .aplayer-time {
        margin-right: 110px;
      }
    }
  }
  @media (max-width: 767px) {
    .aplayer-pic {
      width: 20px;
    }
    .aplayer-controller .aplayer-time  {
      margin-right: 50px;
    }
  }
  @media (max-width: 575px) {
    .aplayer-pic {
      max-width: 35px;
    }
  }
}

.showPlayer_btn {
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  bottom: 15px;
  right: 100px;
  cursor: pointer;
  z-index: 9;
  border-radius: 4px;
  padding: 10px 20px;
  display: flex;
  .icon {
    margin-right: 25px;
    img {
      width: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widget/AudioPlayer/index.vue